/**
 * Smooth Scroll - for anchor links
 */

class SmoothScroll {
    constructor() {
        this.headerHeight = document.querySelector('.site-header')?.offsetHeight || 70;
        this.init();
    }

    init() {
        document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
            anchor.addEventListener('click', (e) => this.handleClick(e, anchor));
        });
    }

    handleClick(e, anchor) {
        const href = anchor.getAttribute('href');
        if (href === '#') return;

        const target = document.querySelector(href);
        if (!target) return;

        e.preventDefault();

        const top = target.getBoundingClientRect().top + window.scrollY - this.headerHeight - 16;

        window.scrollTo({ top, behavior: 'smooth' });

        target.setAttribute('tabindex', '-1');
        target.focus({ preventScroll: true });
    }
}

export default new SmoothScroll();
